import { render, staticRenderFns } from "./screenshot.vue?vue&type=template&id=71af793a&scoped=true&"
import script from "./screenshot.vue?vue&type=script&lang=ts&"
export * from "./screenshot.vue?vue&type=script&lang=ts&"
import style0 from "./screenshot.vue?vue&type=style&index=0&id=71af793a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af793a",
  null
  
)

export default component.exports